import {
  AfterContentInit,
  Component,
  computed,
  contentChildren,
  inject,
  input,
  signal,
  TemplateRef,
  ChangeDetectionStrategy
} from '@angular/core';
import {CardModule} from "primeng/card";
import {FlexModule} from "@ngbracket/ngx-layout";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {NgTemplateOutlet} from "@angular/common";
import {ActionType} from "../../models/action.type";
import {TemplateForDirective} from "../../templating/template-for.directive";

@Component({
  selector: 'app-lib-card',
  imports: [
    CardModule,
    FlexModule,
    NgTemplateOutlet,
  ],
  templateUrl: './card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './card.component.css'
})
export class CardComponent implements AfterContentInit {

  templates = contentChildren(TemplateForDirective);
  title = signal<TemplateRef<unknown>|undefined>(undefined);
  content = signal<TemplateRef<unknown>|undefined>(undefined);
  cardClass = input<string>('');
  cardStyle = input<Partial<CSSStyleDeclaration>>({});

  // eslint-disable-next-line @angular-eslint/no-input-rename
  manualTitle = input<string|null>(null, {alias: 'title'});
  // eslint-disable-next-line @angular-eslint/no-input-rename
  manualContent = input<string|SafeHtml|null>(null, {alias: 'content'});
  // eslint-disable-next-line @angular-eslint/no-input-rename
  manualType = input<ActionType|null>(null, {alias: 'type'});

  titleStr = computed(() => {
    const manualTitle = this.manualTitle();
    return manualTitle;
  });

  type = computed(() => {
    const manualType = this.manualType();
    return manualType;
  });

  protected sanitizer = inject(DomSanitizer);
  msg = computed(() => {
    const manualContent = this.manualContent();
    const html = manualContent || '';
    if (typeof html === 'string') {
      return this.sanitizer.bypassSecurityTrustHtml(html);
    }
    return html;
  });

  ngAfterContentInit() {
    TemplateForDirective.Bind(this, this.templates());
  }

}
